import React from 'react'


const BannerWave = ({
    image,
    topWave,
    bottomWave,
    meet,
    top,
    imageStyle={}
}) => {
    return (
        <section className={`meetting ${top?`meeting-top`:`meeting-bottom`}`} alt={meet} style={{
            backgroundImage: `url(${image})`,
            ...imageStyle
        }}>
            {topWave && (<img className='top-wave md:hidden' src={topWave} />)}
            {bottomWave && (<img className='bottom-wave md:hidden' src={bottomWave} />)}
        </section>
    )
}

export default BannerWave